import {Component, forwardRef} from "@angular/core";
import {FUIAbstractPill} from "../../framework/abstract-pill";
import {NG_VALUE_ACCESSOR} from "@angular/forms";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIMorePillComponent),
            multi: true
        }
    ],
    selector: "fui-more-pill",
    templateUrl: "./more-pill.component.html"
})
export class FUIMorePillComponent extends FUIAbstractPill {
}
